import React from 'react';
import { Route, Redirect } from 'react-router-dom';
import { getAuthToken } from './utils/localStorage';

const PrivateRoute: React.FC<{
  component: any;
  path: string;
  exact: boolean;
  redirectTo: string;
}> = (props) => {
  const token = getAuthToken();
  return token !== null &&
    token !== undefined &&
    token !== 'undefined' ? (
        <Route path={props.path} exact={props.exact} component={props.component} />
    ) : (
        <Redirect to={props.redirectTo} />
    );
};

export default PrivateRoute;
